import { render, staticRenderFns } from "./rwriteoff.vue?vue&type=template&id=c05942f2&scoped=true&"
import script from "./rwriteoff.vue?vue&type=script&lang=js&"
export * from "./rwriteoff.vue?vue&type=script&lang=js&"
import style0 from "./rwriteoff.vue?vue&type=style&index=0&id=c05942f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05942f2",
  null
  
)

export default component.exports